import { Grid, Icon, Typography } from "@mui/material";
import { memo } from "react";

function Nautical() {
  return (
    <Grid container spacing={1}>
      <Grid item xs={6} md={12}>
        <Icon className="wi-yacht-exterior" fontSize="large" />
        <Typography
          variant="overline"
          display="block"
          px={1}
          noWrap
          gutterBottom
        >
          Yacht Exterior
        </Typography>
      </Grid>
      <Grid item xs={6} md={12}>
        <Icon className="wi-yacht-interior" fontSize="large" />
        <Typography
          variant="overline"
          display="block"
          px={1}
          noWrap
          gutterBottom
        >
          Yacht Interior
        </Typography>
      </Grid>
    </Grid>
  );
}

export default memo(Nautical);
